// @ts-strict-ignore
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { AccountNumberTypes, CustomerWallet, LedgerWalletType } from 'types/customers'
import { Currencies } from 'types/types'

interface CustomerWalletSidepanelDetailsProps {
  customerWalletData: CustomerWallet
}

const CustomerWalletSidepanelDetails = ({
  customerWalletData,
}: CustomerWalletSidepanelDetailsProps) => {
  const { t } = useTranslation()

  const fiatWallet = customerWalletData?.ledgers?.find(ledger => {
    if (customerWalletData?.balance?.currencyCode === Currencies.GBP) {
      return (
        ledger?.type === LedgerWalletType.FIAT &&
        ledger?.accountNumberFormat === AccountNumberTypes.SCAN
      )
    }

    return ledger?.type === LedgerWalletType.FIAT
  })

  const labels = useMemo(() => {
    switch (fiatWallet?.accountNumberFormat) {
      case AccountNumberTypes.IBAN:
        return {
          accountNumber: t('iban'),
          bankCode: t('bic'),
        }
      case AccountNumberTypes.SCAN:
        return {
          accountNumber: t('accountNumber'),
          bankCode: t('sortCode'),
        }
      default:
        return {
          accountNumber: t('accountNumber'),
          bankCode: t('bankCode'),
        }
    }
  }, [fiatWallet])

  const accountHolderName = fiatWallet?.accountHolderName || customerWalletData?.name

  return (
    <Box flex gapY={4} width="full" className="flex-col">
      <h4 className="text-h4 text-foreground-prominent">{t('walletDetails')}</h4>
      {accountHolderName && (
        <DataListItem
          id={accountHolderName}
          title={t('accountHolderName')}
          body={accountHolderName}
        />
      )}
      {!!fiatWallet && (
        <>
          {fiatWallet?.accountNumber && (
            <DataListItem
              id={fiatWallet?.accountNumber}
              title={labels?.accountNumber}
              body={ellipseMiddleText(fiatWallet?.accountNumber, 20, 10)}
              copyText={fiatWallet?.accountNumber}
            />
          )}
          {fiatWallet?.code && (
            <DataListItem
              id={fiatWallet?.code}
              title={labels?.bankCode}
              body={fiatWallet?.code}
              copyText={fiatWallet?.code}
            />
          )}
        </>
      )}
    </Box>
  )
}

export default CustomerWalletSidepanelDetails
